import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FindTaskLooseComponent } from './find-task-loose.component';

const routes: Routes = [{ path: '', component: FindTaskLooseComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FindTaskLooseRoutingModule {}